import styled from 'styled-components';

export const SealContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 20px;
    background-color: rgb(206, 222, 200);
    border-radius: 10px;
    margin-top: 20px;
`;

export const SealWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 80%;
    max-width: 600px;
    gap: 20px;
`;

export const SealImage = styled.img`
    width: 200px; /* Resizing to 200x200 */
    height: 200px;
    object-fit: contain;
    border-radius: 10px;
`;

export const SealText = styled.p`
    font-size: 18px;
    color: #333;
    font-weight: bold;
`;

export const LoadingText = styled.p`
    font-size: 16px;
    color: #666;
`;

export const SealButton = styled.button`
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 16px;
    color: white;
    background-color: rgb(7, 58, 4);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
        background-color: rgb(165, 220, 171);
    }
`;
